import React, { useState } from "react";
import { Wordmark } from "./Logo";
import { MapPin, Phone, Mail, Send } from "lucide-react";
import { toast } from "sonner";

export function Footer() {
  const [msg, setMsg] = useState({ name: "", email: "", body: "" });
  const submit = (e) => { e.preventDefault(); toast.success("Message sent — Christopher will get back to you soon."); setMsg({ name: "", email: "", body: "" }); };

  return (
    <footer id="contact" className="border-t border-border bg-card/40 grain" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 lg:grid-cols-2">
        <div>
          <Wordmark />
          <p className="mt-4 max-w-sm text-sm text-muted-foreground leading-relaxed">
            Verified peer-to-peer Wi-Fi sharing for travelers and neighbors. Affordable, secure, and effortless internet — anywhere.
          </p>
          <div className="mt-8 space-y-3" data-testid="contact-info">
            <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Contact Us</p>
            <p className="text-sm font-medium">Christopher Ferrer</p>
            <a href="https://maps.google.com/?q=510 S. Highland Street Memphis TN 38111" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"><MapPin size={15} /> 510 S. Highland Street, Memphis, TN 38111</a>
            <a href="tel:+19012298694" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="contact-phone"><Phone size={15} /> (901) 229-8694</a>
            <a href="mailto:ferre.chris@icloud.com" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="contact-email"><Mail size={15} /> ferre.chris@icloud.com</a>
          </div>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-4">Send a message</p>
          <form onSubmit={submit} className="space-y-3 max-w-md" data-testid="contact-form">
            <div className="grid grid-cols-2 gap-3">
              <input required value={msg.name} onChange={(e) => setMsg({ ...msg, name: e.target.value })} placeholder="Your name" className="h-11 px-4 rounded-xl bg-background border border-input text-sm outline-none focus:border-ring" data-testid="contact-name-input" />
              <input required type="email" value={msg.email} onChange={(e) => setMsg({ ...msg, email: e.target.value })} placeholder="Email" className="h-11 px-4 rounded-xl bg-background border border-input text-sm outline-none focus:border-ring" data-testid="contact-email-input" />
            </div>
            <textarea required value={msg.body} onChange={(e) => setMsg({ ...msg, body: e.target.value })} placeholder="How can we help?" rows={4} className="w-full px-4 py-3 rounded-xl bg-background border border-input text-sm outline-none focus:border-ring resize-none" data-testid="contact-message-input" />
            <button type="submit" className="h-11 px-6 rounded-xl bg-foreground text-background text-sm font-medium hover:opacity-90 transition-opacity flex items-center gap-2" data-testid="contact-submit"><Send size={15} /> Send message</button>
          </form>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} OPNWiFi — opnwifi.com. All rights reserved.</span>
          <span>Built in Memphis, TN 🤝 Rooted in Brooklyn, NY</span>
        </div>
      </div>
    </footer>
  );
}
